export default __webpack_public_path__ + "static/media/img_transparet_pricing.87ed61cf.png";